"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArrayMetadataWithArray = buildArrayMetadataWithArray;
function buildArrayMetadataWithArray(newArrayMetadata) {
    return (arrayMetadata) => {
        arrayMetadata.push(...newArrayMetadata);
        return arrayMetadata;
    };
}
//# sourceMappingURL=buildArrayMetadataWithArray.js.map